import { useState, useEffect} from 'react'
import { toast } from 'react-hot-toast'
import { Select } from 'antd'
import { ButtonFilledAutoWidth } from '../../components/button'
import { TextInput } from '../../components/input'
import GoBack from '../../components/back/GoBack'
import SettingsMenu from '../staticscreens/SettingsMenu'
import { CreateSubscriptionService, GetSubscriptionService, UpdateSubscriptionService } from '../../services/admin/SubscriptionServices'
import { CreateCurrentLinkModelService, GetCurrentLinkModelService, UpdateCurrentLinkModelService } from '../../services/admin/CurrentLinkModelServices'

function CurrentLinkModel() {
 
  const [data,setdata] = useState({name:'',});  
  const [error,seterror] = useState({name:'',}); 


  const stages = ['Live-Kit','G-Meet']
  
   useEffect(()=>{
      getdata()
    },[])
  
    async function getdata() {
      const response = await GetCurrentLinkModelService()
      if(response?.data?.datas?.length > 0){
          setdata(response?.data?.datas[0])
      }
    }

  function handlechange(e){
    setdata({...data,[e.target.name] : e.target.value})
    seterror({...error,[e.target.name]:''})
  }
  

  async function resetform(){
    setdata({name:'',})
    seterror({name:'',})
  }

  async function submitdata() {
     if(!data.name){
        seterror({...error,name:'This field is required to make changes*'})
    }else{
    if(data?._id === undefined || data?._id === null){
        const response = await CreateCurrentLinkModelService(data)
        if (response.status === 201) {
          resetform()
          getdata()
          toast.success('Current Link Model Created Successfully')
        } 
    }else{
       const response = await UpdateCurrentLinkModelService(data,data?._id)
        if (response.status === 200) {
          resetform()
          getdata()
          toast.success('Current Link Model Update Successfully')
        } 
    }
    }
  }

  function openFile(v){
    let url = `${process.env.REACT_APP_BACKEND_IMAGE_URL}${v}`
    window.open(url,'_blank')
  }


  

  

  return (
    <div className='md:flex '>


    <SettingsMenu />
 
  <div className='sm:w-full lg:w-72 px-4 pt-5' >


      <GoBack /> 
      
      

        <h6 className='font-bold'>Current Link Model</h6>
        <h6 className='text-[10px] bg-slate-100 p-2 font-[500] leading-snug' >Use the below form to create / update <b>Current Link Model</b>.</h6>
     

       
        <div>
             <h6 className='text-[11px] mb-1 mt-2'>Type </h6>
                <Select
                  value={data.name} 
                  filterOption={false}
                  bordered={false}
                  placeholder="" 
                  onChange={(e)=>{setdata({...data,name:e});seterror({...error,name:''})}} 
                  options={stages?.map((s)=>({label:s,value:s}))} 
                  className='w-full border border-l-4 border-l-slate-700 outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
      
                  />
            </div> 

        {/* <TextInput 
            mandatory={true}
            label={'Type'}  
            variant="standard"
            name="name"
            type="number"
            error={error.name}
            value={data.name}
            handlechange={handlechange}
            placeholder=""
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/> */}

          
          <div className='my-5'>
           <ButtonFilledAutoWidth btnName="Save"  onClick={submitdata} />  
          </div>



    </div>
    </div>
  )
}

export default CurrentLinkModel